<div class="ec-gse-month-container">
    <form [formGroup]="dateForm" fxLayout="column" fxLayoutGap="20px">
        <div fxLayout="row" fxLayoutAlign="center center">
            <app-icon class="icon-xl txt-h-16-7" name="fal-calendar-alt"></app-icon>
        </div>
        <div fxLayout="column" fxLayoutAlign="start start" class="txt">
            <ng-container *ngIf="content === CONTENT_DIALOG.GSE">
                <span>{{'GSE data can only be entered by single month'|i18n}}.</span>
                <span>{{'Choose an unpaid month'|i18n}}:</span>
            </ng-container>
            <ng-container *ngIf="content === CONTENT_DIALOG.YEARLY">
                <span>{{'Configurations can only be made on annual periods (January to December) and are applied to unpaid months'|i18n}}.</span>
                <span>{{'Select a year to proceed with its configuration'|i18n}}:</span>
            </ng-container>
            <ng-container *ngIf="content === CONTENT_DIALOG.MONTHLY">
                <span>{{'Invoiced data can only be entered for a single month'|i18n}}.</span>
                <span>{{'Choose an unpaid month'|i18n}}:</span>
            </ng-container>
        </div>
        <div class="mt-24" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
            <div fxFlex="25" app-input-container>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                    <input app-input
                           [matDatepicker]="dateSelection === DATE_SELECTION.MONTH ? monthSelection : yearSelection"
                           formControlName="selectedDate"
                           [matDatepickerFilter]="dateFilter"
                           [min]="minDate"
                           [max]="maxDate">
                    <mat-datepicker-toggle matSuffix [for]="dateSelection === DATE_SELECTION.MONTH ? monthSelection : yearSelection"></mat-datepicker-toggle>
                    <mat-datepicker #monthSelection
                                    startView="multi-year"
                                    (monthSelected)="onSetDate($event); monthSelection.close()">
                    </mat-datepicker>
                    <mat-datepicker #yearSelection
                                    startView="multi-year"
                                    (yearSelected)="onSetDate($event); yearSelection.close()">
                    </mat-datepicker>
                </div>
                <div *ngIf="dateForm.controls.selectedDate.invalid && dateForm.controls.selectedDate.dirty" app-error>
                    {{ 'Invalid date'|i18n }}
                </div>
            </div>
        </div>
    </form>
</div>
